import { allowedCSVSizeForGroupCreation } from '@constants/file';

export const acceptedLeadAdditionFileFormats =
  '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const LEAD_BULK_UPLOAD_MAX_ROWS = 100;
export const LEAD_BULK_UPLOAD_MAX_SIZE = allowedCSVSizeForGroupCreation; // 2MB

export const defaultLeadTemplateHeaders: string[] = [
  'Name',
  'Email ID',
  'Country Code',
  'Mobile Number',
  'Secondary Country Code',
  'Secondary Mobile Number',
  'Country',
  'State',
  'City',
  'Pin Code',
  'Category',
  'Source',
  'Assignee',
  'Status',
  'Deal Value',
  'Priority',
  'Description',
  'Tags' // comma-separated tag ids
];

export const templateLeadDummyData: string[] = [
  'John Doe', // Name
  'john.doe@example.com',
  '91',
  '9876543210', // Mobile Number
  '91',
  '', // Secondary Mobile Number
  '', // Country
  '', // State
  '', // City
  '', // Pin Code
  '', // Category
  'Website', // Source
  '', // Assignee
  'New', // Status
  '10000', // Deal Value
  'Medium', // Priority
  '', // Description
  '' // Tags
];
